import EventsIcons from './component'

export default EventsIcons
